export default __webpack_public_path__ + "static/media/diet.c04c4d0a.svg";